import { useContext } from 'react';
import { ApiServicesContext } from './ApiServicesContext';

export function useApiServices() {
  const contextValue = useContext(ApiServicesContext);

  if (!contextValue) {
    throw new Error('Wrap your components tree with a ApiServicesProvider component');
  }

  return contextValue;
}
